import { useQuery } from "@tanstack/react-query";
import {
  fetchCategories,
  fetchCategorySeries,
  fetchSeriesDetails,
} from "../api/products";

// Получение списка категорий продуктов
export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const data = await fetchCategories();
      return data;
    },
  });
};

// Получение списка серий для конкретной категории продуктов
export const useCategorySeries = (categoryId) => {
  return useQuery({
    queryKey: ["categorySeries", categoryId],
    queryFn: async () => {
      const data = await fetchCategorySeries(categoryId);
      return data;
    },
    enabled: !!categoryId, // выполняем запрос только при наличии categoryId
  });
};

// Получение детальной информации о конкретной серии продукта
export const useSeriesDetails = (seriesId) => {
  return useQuery({
    queryKey: ["seriesDetails", seriesId],
    queryFn: async () => {
      const data = await fetchSeriesDetails(seriesId);
      return data;
    },
    enabled: !!seriesId, // выполняем запрос только при наличии seriesId
  });
};
